import { useEffect } from "react";
import { useTemplatesContext } from "../context/templatesContext";
import { useShiftParameters } from "./useTemplatesQueries";

type Props = {
	setIsParametersLoading: (isLoading: boolean) => void;
	setParametersError: (err: string) => void;
};

// Fetches shifts-per-day via React Query and keeps it in the reducer as form
// config (consumed by the Create/Edit template modals to convert days <-> shifts).
export const useLoadPeriodPerDay = ({
	setIsParametersLoading,
	setParametersError,
}: Props) => {
	const {
		state: { searchAssetIdToTable },
		actions,
	} = useTemplatesContext();

	const { data, isLoading, error } = useShiftParameters(searchAssetIdToTable);

	useEffect(() => {
		setIsParametersLoading(isLoading);
	}, [isLoading]);

	useEffect(() => {
		if (data != null) actions.setShiftsPerDay(data);
	}, [data]);

	useEffect(() => {
		if (error) setParametersError((error as Error).message);
	}, [error]);
};
